<template>
  <v-container fluid light>
    <v-row align="center" justify="center">
      <v-col>
        <v-data-table :headers="headers"
                      fixed-header
                      fixed-footer
                      :hide-default-footer="true"
                      height="600px"
                      :items="favoriteLists"
                      :options.sync="options"
                      :loading="loading"
                      class="elevation-1"
                      item-key="id"
                      dense>
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title v-if="department!=null && location!=null">{{department.name}} Favorite Lists <span class="text-sm-body-1">for</span> {{location.name}}</v-toolbar-title>
              <FavoritesListDialog actionIcon="mdi-playlist-plus" actionColor="green" action="Create" class="pa-2" :onDataUpdate="listUpdated" caption="New"></FavoritesListDialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.id`]="{ item }">
            <v-row>
              <v-col>
                <FavoritesListDialog actionIcon="mdi-playlist-edit" actionColor="blue" action="Save" :favoritesList="item" class="pa-2" :onDataUpdate="listUpdated" caption="Edit"></FavoritesListDialog>
              </v-col>
              <v-col>
                <FavoritesListDialog v-if="!item.isDefault" actionIcon="mdi-playlist-remove" actionColor="red" action="Delete" :favoritesList="item" class="pa-2" :onDataUpdate="listUpdated" caption="Delete"></FavoritesListDialog>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.listName`]="{ item }">
            <div class="text-left justify-center">{{ item.listName }}</div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from "axios";
  import FavoritesListDialog from './FavoritesListDialog.vue';
  
  export default {
    components: {
      FavoritesListDialog
    },
    data: () => ({
      favoriteLists: [],
      locationId: null,
      locationDepartmentId: null,
      location: null,
      department: null,
      loading: true,
      headers: [
        {
          text: 'Actions',
          width: '25%',
          value: 'id',
          sortable: false
        },
        {
          text: 'Name',
          align: 'start',
          value: 'listName',
          width: '75%',
          sortable: false
        }
      ],
      options: {},
    }),
    async mounted() {
      this.locationId = this.$route.params.locationId;
      this.locationDepartmentId = this.$route.params.locationDepartmentId;
      this.favoriteLists = await this.getFavoriteListsFromApi();
      this.location = await this.getLocationFromApi(this.locationId);
      this.department = await this.getDepartmentFromApi(this.locationDepartmentId);
      this.loading = false;
    },
    methods: {
      async getFavoriteListsFromApi() {
        let response = await axios.get(`/api/MaterialFavoriteList/departmentlist/${this.locationDepartmentId}`);
        return response.data;
      },
      async getLocationFromApi() {
        let response = await axios.get(`/api/Location/${this.locationId}`);
        return response.data;
      },
      async getDepartmentFromApi() {
        let response = await axios.get(`/api/Location/${this.locationId}/departments/${this.locationDepartmentId}`);
        return response.data;
      },
      async listUpdated() {
        this.loading = true;
        this.favoriteLists = await this.getFavoriteListsFromApi();
        this.loading = false;
      }
    }
  }
</script>

<style scoped>

</style>